import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-avatar',
    templateUrl: './avatar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AvatarComponent implements OnInit {
  @Input() type?: string;
  @Input() imgSrc?: string;

  constructor() {}

  ngOnInit() {}
}
